import { TITLE_ON_TRUNCATE_CLASSNAME } from './constants';

/** function: getTitleOnTruncateElements
 *  @returns all rds-handled-titleOnTruncate class elements
 * */
export const getTitleOnTruncateElements = () => document.getElementsByClassName(TITLE_ON_TRUNCATE_CLASSNAME);

/**
 * This logic sets the title attribute for tooltipOnTruncate class elements
 **/
export const addRemoveTitleAttribute = (singleElement) => {
  if (singleElement && singleElement.offsetWidth && singleElement.scrollWidth) {
    if (singleElement.offsetWidth < singleElement.scrollWidth) {
      singleElement.setAttribute('title', singleElement.innerHTML);
    } else {
      singleElement.setAttribute('title', '');
    }
  }
};
